<template>
  <form @submit.prevent="submit()" class="flex flex-col gap-4">
    <h6>{{ "Enviar arquivo" }}</h6>

    <label
      for="input-student-activity"
      class="border border-dashed p-6 h-32 flex flex-col justify-center items-center"
      v-if="!form?.file"
      :class="[{ 'border border-h-error-500': v$?.form?.file?.$error }]"
    >
      <v-icon name="bi-file-earmark-arrow-up" :scale="2" />
      <h5>{{ "Selecionar arquivo para enviar" }}</h5>
      <input
        type="file"
        class="hidden"
        :multiple="false"
        id="input-student-activity"
        @change="onSelectFile"
      />
    </label>
    <div v-else class="border p-6 h-32 flex flex-col gap-2">
      {{ "Arquivo selecionado:" }}
      <div
        class="bg-h-primary-50 w-48 sm:w-52 md:w-72 p-3 rounded-sm flex flex-row gap-2"
      >
        <v-icon name="bi-file-earmark-text-fill" />
        <p class="flex-1">{{ form?.file[0]?.name }}</p>

        <v-icon name="md-close" @click.prevent="onExcludeFile" />
      </div>
    </div>
    <Errors :errors="v$.form.file?.$errors" />

    <h6>{{ "Comentários" }}</h6>
    <textarea
      v-model="form.textAnswer"
      :placeholder="'Escreva aqui uma mensagem para o seu professor'"
      :class="[{ 'border border-h-error-500': v$?.form?.textAnswer?.$error }]"
      class="p-inputtext h-56"
      style="resize: none"
    />
    <Errors
      :errors="v$?.form?.textAnswer?.$errors"
      :actualLength="form?.textAnswer?.length"
      :maxLength="1024"
    />

    <div class="flex flex-row gap-2 items-center mb-4">
      <v-icon name="io-information-circle-outline" :scale="1.4" />
      <p>{{ "O aluno deverá enviar pelo menos um arquivo ou comentário." }}</p>
    </div>
    <div class="flex flex-row-reverse gap-4">
      <Button
        :label="'Enviar'"
        class="btn-primary"
        type="submit"
        :loading="loading.studentActivity"
      />
      <Button
        :label="'Cancelar'"
        class="btn-outline"
        @click.prevent="onCloseForm"
        :disabled="loading.studentActivity"
      />
    </div>
  </form>
</template>
<script lang="ts">
import { maxLength } from "@/locale/locale.config";
import { ActivityRest } from "@/services/rest/activity.rest";
import { Messages } from "@/utils/messages.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { defineComponent } from "vue";
import { buildData } from "./form.utils";
export default defineComponent({
  props: {
    activityId: {
      type: String,
    },
    showDialog: {
      type: Boolean,
    },
  },
  data() {
    return {
      form: {
        file: null as File[] | null,
        textAnswer: "" as string,
      },
      loading: {
        studentActivity: false,
      },
    };
  },
  emits: ["update:visible", "activitySent"],
  validations() {
    const atLeastOne = helpers.withMessage(
      "É necessário enviar um arquivo ou escrever um comentário",
      (value: any, form: any) => {
        const hasFiles = form.file && form.file.length > 0;
        const hasTextAnswer =
          form.textAnswer && form.textAnswer.trim().length > 0;
        return hasFiles || hasTextAnswer;
      }
    );
    return {
      form: {
        file: { atLeastOne: atLeastOne },
        textAnswer: {
          maxLength: maxLength(1024),
          atLeastOne: atLeastOne,
        },
      },
    };
  },
  computed: {
    rest(): ActivityRest {
      return new ActivityRest();
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  methods: {
    submit() {
      this.v$.$validate();
      if (this.v$.$invalid) return;
      this.sendStudentActivity();
    },
    onSelectFile(event: any) {
      if (event?.target?.files?.length > 0) {
        this.form.file = Array.from(event.target?.files);
      }
    },
    onExcludeFile() {
      this.form.file = null;
    },
    onCloseForm() {
      this.$emit("update:visible", false);
    },
    sendStudentActivity() {
      this.loading.studentActivity = true;
      const data = buildData(this.form);
      this.rest.updateStudentActivity(this.activityId!, data).subscribe({
        next: () => {
          this.loading.studentActivity = false;
          this.$emit("activitySent");
          this.$emit("update:visible", false);
          this.$toast.add(ToastFactory.success(Messages.ACTIVITY_STUDENT_SENT));
        },
        error: () => {
          this.loading.studentActivity = false;
        },
        complete: () => {
          this.loading.studentActivity = false;
        },
      });
    },
  },
});
</script>
